import script from "./PaginationApi.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationApi.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationApi.vue?vue&type=style&index=0&id=a7a51a4e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a51a4e"]])

export default __exports__